module.exports = __webpack_public_path__ + "img/w3_search_light.a3cc87b1.png";